import React from 'react'
import { Typography, Grid } from '@material-ui/core'
import ArticleCard from './ArticleCard'


class FeaturedArticles extends React.Component {
    state = {
        redirectURL: null
    }

    render() {
        const { articles } = this.props
        return (
            <div>
                <Typography variant="h2" style={{ marginBottom: 10, fontWeight: 'bold' }}>Latest Articles</Typography>
                <Grid container spacing={2}>
                    {articles && articles.map(a => (
                        <Grid key={a.id} item sm={6} xs={12}>
                            <ArticleCard article={a} />
                        </Grid>
                    ))}
                </Grid>
            </div>
        )
    }
}

export default FeaturedArticles